module.exports = "<div class=\"header_flex\">\n  <a\n    *ngFor=\"let page of formattedPaths\"\n    class=\"route_btn\"\n    mat-button\n    (click)=\"navigate(page.path)\"\n    [ngClass]=\"page.isActive ? 'active' : 'inactive'\"\n    ><mat-icon *ngIf=\"page.icon\" class=\"icons\">{{page.icon}}</mat-icon>{{page.title}}</a\n  >\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/layout/header-nav/header-nav.component.html
// module id = ../../../../../src/app/components/layout/header-nav/header-nav.component.html
// module chunks = main